module.exports = __webpack_public_path__ + "assets/img/moments.ec8b5aa1.png";